import React from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "animate.css/animate.css";
import "font-awesome/css/font-awesome.css";
import { Link } from "react-router-dom";
import logo from "./logo.svg";
import "./Login.css";
import ReturnClassToken from "./ReturnClassToken";


export default function Login() {

    const navigate = useNavigate();
    //Implement Captcha
    const apiurl = window.SERVICE_URL;
    //const apiurl = configData.BASE_URL;
    //alert(process.env.REACT_APP_API_URL);


    const characters = 'abcd1234';
    function generateString(length) {
        let result = '';
        const charactersLength = characters.length;
        for (let i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    }

    const captch = generateString(6)

    const checkCaptcha = e => {

        var element = document.getElementById("spcaptchaerror");
        var inputData = document.getElementById("inputType");
        var userc = document.getElementById("inputType").value;

        inputData.disabled = true;
        element.disabled = true;

        if (userc.trim().length > 0) {
            if (captch == userc) {

                return true;
            }
            else {

                var myFunction = function () {
                    inputData.disabled = false;
                    inputData.value = '';
                    element.style.display = "none";
                };
                setTimeout(myFunction, 5000);
                return false;
            }
        }
        else {
            //element.style.cursor = "not-allowed";
            // element.innerHTML = "Please Enter Captcha!";
            //element.style.display = "block";
            var myFunction = function () {
                inputData.disabled = false;
                inputData.value = '';
                element.style.display = "none";
            };
            setTimeout(myFunction, 5000);
            return false;
        }
    };
    //Implement Captcha


    function validateform() {
        var names = document.getElementById("UserName").value;
        var passwords = document.getElementById("Password").value;

        if (names == null || names == "") {
            var username = document.getElementById("UserNameErr");
            username.innerHTML = "User Name can't be blank";
            username.style.color = "red";
            return false;
        }
        if (passwords.length == 0) {
            var userpassword = document.getElementById("PasswordErr");
            userpassword.innerHTML = "password can't be blank .";
            userpassword.style.color = "red";
            return false;
        }
        return true;

    }

    const login = async (e) => {
        e.preventDefault();
        debugger;
        validateform();
        if (checkCaptcha(e)) {
            // console.log(input);
            var name = document.getElementById("UserName").value;
            var password = document.getElementById("Password").value;
            const loginForm = {
                UserName: name,
                Password: password

            };

            // addPosts(loginForm);
            // .post(apiurl + `api/LoginUser`, loginForm, {
            await axios
                .post(apiurl + `api/LoginUser`, loginForm, {
                    headers: {
                        "Content-Type": "application/json",
                    },
                })
                .then((result) => {
                    debugger;
                    if (result.data.outMessage === "Login Successfully") {
                        ReturnClassToken.AccessToken = result.data.accessToken;
                        ReturnClassToken._jti = result.data._jti;
                        ReturnClassToken.ExpiresOn = result.data.expiresOn;
                        ReturnClassToken.LoginID = result.data.loginID;
                        ReturnClassToken.UserName = result.data.userName;
                        ReturnClassToken.FullName = result.data.fullName;
                        ReturnClassToken.EmailID = result.data.emailID;
                        ReturnClassToken.MobileNumber = result.data.mobileNumber;
                        ReturnClassToken.AddedOn = result.data.addedOn;
                        ReturnClassToken.UserID = result.data.userID;
                        ReturnClassToken.PartnerID = result.data.partnerID;
                        ReturnClassToken.IsSubAdmin = result.data.isSubAdmin;
                        ReturnClassToken.IsFullRights = result.data.isFullRights;
                        ReturnClassToken.OutMessage = result.data.outMessage;
                        localStorage.setItem("loginsession", JSON.stringify(ReturnClassToken));

                        //document.getElementById("loginbtn").click(); // Not Working When Deploy On Produciton
                        navigate('dashboard');
                        //window.location.reload();

                    } else {
                        alert(result.data.outMessage);
                        console.log(result.data.outMessage);
                    }
                });
        }
        else {
            alert('Invalid Captcha...');
        }




    };


    return (
        <>



            <div className="container-fluid">
                <a href="dashboard" id="loginbtn" style={{ display: "none" }}>login</a>
                <div className="row">
                    <div className="col-md-4 p-5">
                        <center>
                            {" "}
                            <img src={logo} alt="brand-logo" className="mb-2 w-50" />
                        </center>
                        <h5 align="center" className="title-subheading mb-5">
                            Sign In To Questopedia
                        </h5>
                        <form>
                            <div className="form-outline mb-3">
                                <label className="form-label" htmlFor="form2Example1">
                                    Email address
                                </label>
                                <input
                                    type="email"
                                    id="UserName"
                                    className="form-control"
                                    placeholder="UserName"
                                    name="UserName"

                                    required
                                />
                                <p id="UserNameErr"></p>
                                {/* <input type="email" id="UserName" className="form-control" /> */}
                            </div>

                            <div className="form-outline mb-3">
                                <label className="form-label" htmlFor="Password">
                                    Password
                                </label>
                                <input
                                    type="password"
                                    id="Password"
                                    className="form-control"
                                    placeholder="Password"
                                    name="Password"

                                    required

                                />
                                <p id="PasswordErr"></p>
                            </div>

                            <div className="row form-outline mb-3">
                                <div className="col-md-8">
                                    <input type="text" id="inputType" className="form-control" placeholder="Enter Captcha" name="username"
                                        autoComplete="off"
                                    />
                                    <span className="text-danger" id="spcaptchaerror"></span>
                                </div>
                                <div className="col-md-4">
                                    <div className='text-center alert-success px-2 py-1'>
                                        <h4 id="captcha" style={{ margin: "0", userSelect: "none" }} > {captch}</h4>
                                    </div>
                                </div>
                            </div>

                            <div className="row mb-3">
                                <div className="col d-flex justify-content-center">
                                    <div className="form-check">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            value=""
                                            id="form2Example31"
                                            checked
                                        />
                                        <label
                                            className="form-check-label"
                                            htmlFor="form2Example31"
                                        >
                                            Remember me
                                        </label>
                                    </div>
                                </div>

                                <div className="col">
                                    <a href="#!">Forgot password?</a>
                                </div>
                            </div>

                            <button
                                type="sumbit"
                                onClick={login}
                                className="btn btn-primary btn-block mb-3"
                                id="succesBTM"
                            >
                                Sign in
                            </button>

                            <div className="text-center">
                                <p>
                                    Not a member? <Link to="/signup"> Register</Link>
                                </p>
                            </div>
                        </form>
                    </div>
                    <div className="col-md-8 rightbox">
                        <h3 className="title mt-3">Welcome to Questopedia</h3>
                        <div className="yoc-login__desc">
                            The Question Paper Generator Platform{" "}
                        </div>
                        <h6 className="brand-title" align="center">
                            Questopedia provides the services to care for business
                        </h6>

                        <div className="row mt-5">
                            <div className="col-md-4">
                                <div className="feature-box">
                                    <div className="iconbox">
                                        <i className="fa fa-newspaper-o"></i>
                                    </div>
                                    <h4 className="featureheading">feature 1</h4>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="feature-box">
                                    <div className="iconbox">
                                        <i className="fa fa-newspaper-o"></i>
                                    </div>
                                    <h4 className="featureheading">feature 2</h4>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="feature-box">
                                    <div className="iconbox">
                                        <i className="fa fa-newspaper-o"></i>
                                    </div>
                                    <h4 className="featureheading">feature 3</h4>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="feature-box">
                                    <div className="iconbox">
                                        <i className="fa fa-newspaper-o"></i>
                                    </div>
                                    <h4 className="featureheading">feature 4</h4>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="feature-box">
                                    <div className="iconbox">
                                        <i className="fa fa-newspaper-o"></i>
                                    </div>
                                    <h4 className="featureheading">feature 5</h4>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="feature-box">
                                    <div className="iconbox">
                                        <i className="fa fa-newspaper-o"></i>
                                    </div>
                                    <h4 className="featureheading">feature 6</h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
